import { render, staticRenderFns } from "./ProcessExaminationQrcode.vue?vue&type=template&id=1040b336&scoped=true"
import script from "./ProcessExaminationQrcode.vue?vue&type=script&lang=js"
export * from "./ProcessExaminationQrcode.vue?vue&type=script&lang=js"
import style0 from "./ProcessExaminationQrcode.vue?vue&type=style&index=0&id=1040b336&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1040b336",
  null
  
)

export default component.exports